module.exports = __webpack_public_path__ + "img/22_44.d23d2da0.png";